import React from 'react';
import PropTypes from 'prop-types';

// Лейбл (.ctl-label) + выпадающий список (.input). Переиспользуемый контрол.
export default function LabeledSelect({ label, value, onChange, options, placeholder, className }) {
    return (
        <div className={className}>
            {label && <label className="ctl-label">{label}</label>}
            <select className="input sel" value={value} onChange={onChange}>
                {placeholder && <option value="">{placeholder}</option>}
                {options.map(opt => (
                    <option key={opt.key} value={opt.key}>{opt.value}</option>
                ))}
            </select>
        </div>
    );
}

LabeledSelect.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        value: PropTypes.string.isRequired
    })).isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string
};

LabeledSelect.defaultProps = {
    label: undefined,
    placeholder: undefined,
    className: undefined
};
